export const PACING_OPTIONS = [
  { value: 'deliberate', label: 'Deliberate' },
  { value: 'energetic', label: 'Energetic' },
  { value: 'smooth', label: 'Smooth' },
  { value: 'assertive', label: 'Assertive' },
  { value: 'animated', label: 'Animated' },
  { value: 'thoughtful', label: 'Thoughtful' },
];

export const HUMOR_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'witty_and_clever', label: 'Witty & Clever' },
  { value: 'sarcastic_and_dry', label: 'Sarcastic & Dry' },
  { value: 'pun_based', label: 'Pun-based' },
  { value: 'goofy_and_playful', label: 'Goofy & Playful' },
  { value: 'self_deprecating', label: 'Self-deprecating' },
];

const createLabelMap = (options) =>
  options.reduce((acc, option) => {
    acc[option.value] = option.label;
    return acc;
  }, {});

export const PACING_LABELS = createLabelMap(PACING_OPTIONS);
export const HUMOR_LABELS = createLabelMap(HUMOR_OPTIONS);
